import {VimeoBackground} from "@/components/Video/VimeoBackground";
import * as C from "@/components";
import React from "react";
import { ContentItem } from "@api";

interface SnaptixPopOpenCardProps {
    videoId: number;
    pageContent: Record<string, ContentItem>;
}

export const SnaptixPopOpenCard = ({ pageContent, videoId }: SnaptixPopOpenCardProps) => (
    <C.Card className='mx-3 my-3 w-full md:w-[36.7%] lg:w-[37.6%] relative' style={{ padding: 0 }}>
        <div className="absolute w-full z-[21] pt-10 md:pt-20">
            <h3 className='font-semibold text-3xl md:text-4xl text-center max-w-[350px] mx-auto max-md:px-4'>
                {pageContent["key-benefits.1.headline"]?.data ?? ""}</h3>
        </div>
        <VimeoBackground videoId={videoId} unlistedPrivacyHash={'6fce618f26'} isVideoUnlisted />
    </C.Card>
);
